module.exports = __webpack_public_path__ + "static/banner-pic-91c92639b05bfdac0fbd7bd00c1c10cf.png";